// Data do calendário (Date) -> 'yyyy-MM-dd'; devolve null quando vazia ou inválida
export function dataParaIso(valor) {
  if (!valor) return null
  const data = valor instanceof Date ? valor : new Date(valor)
  if (Number.isNaN(data.getTime())) return null
  const mes = `${data.getMonth() + 1}`.padStart(2, '0')
  const dia = `${data.getDate()}`.padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}
